import type { PaymentIntentSnapshot } from '../interfaces/paymentIntentSnapshot.interface';

export function isPaymentIntentSnapshotValid(
  snapshot: PaymentIntentSnapshot | null,
  current: PaymentIntentSnapshot,
): snapshot is PaymentIntentSnapshot {
  if (!snapshot) return false;
  return snapshot.amount === current.amount && snapshot.planCode === current.planCode;
}
